import React, { useEffect, useState } from "react";
import "../Css/FooterCountry.css";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdCall } from "react-icons/io";
import FooterCountryData from "../Components/Data/FooterCountryData";
import { Button, Form, Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { MdEmail } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import { Fade } from "react-awesome-reveal";
import { useCartContext } from "../context/addToCart";

const FooterCountry = () => {
  const [countryDetails, setCountryDetails] = useState({});
  const { makeAndEnquiry } = useCartContext();
  const [form] = Form.useForm();

  const handleCountryAddress = (name) => {
    const getCurrentAddres = FooterCountryData.find(
      (v) => v.countryName === name
    );
    setCountryDetails(getCurrentAddres);
  };
  useEffect(() => {
    handleCountryAddress("India");
  }, []);

  const onFinish = (val) => {
    const name = val.first_name + " " + val.last_name;
    if (
      makeAndEnquiry(
        name,
        "",
        val.email,
        val.message,
        "Country Enquiry",
        null,
        null,
        null
      )
    ) {
      message.success(
        "Thank you for your inquiry. Our team will connect with you shortly."
      );
      form.resetFields();
    }
  };

  return (
    <>
      <section className="sectionDiv branch-contact">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h6 className="text-white">
                Worldwide Dealers{" "}
                <small className="text-gray">
                  Spread across the globe to best serve our clients!
                </small>
              </h6>
              <Fade triggerOnce direction="down">
                <div className="row row-cols-lg-7 mt-4">
                  {FooterCountryData.map(
                    (val) =>
                      val.img && (
                        <div className="col p-3 p-md-0 m-0">
                          <div
                            className={`countryLogo ${
                              countryDetails.countryName === val.countryName &&
                              "active"
                            }`}
                            onClick={() =>
                              handleCountryAddress(val.countryName)
                            }
                          >
                            <img src={val.img} alt={val.countryName} />
                            <br />
                            <span>{val.countryName}</span>
                          </div>
                        </div>
                      )
                  )}
                </div>
              </Fade>
              <Fade triggerOnce direction="up">
                <div className="detail mt-5">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="detail-card">
                        <div className="icon">
                          <FaLocationDot />
                        </div>
                        <div className="content">
                          <h5>{countryDetails?.location}</h5>
                          <p>{countryDetails?.address}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="detail-card">
                        <div className="icon">
                          <IoMdCall />
                        </div>
                        <div className="content">
                          <h5>Contact Us</h5>
                          <p>Phone: {countryDetails?.phoneNumber}</p>
                          <p>Email: {countryDetails?.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
            <div className="col-md-4 mt-5 mt-md-0">
              <Fade triggerOnce direction="right">
                <div className="formCard">
                  <div className="formTitle">Contact Us</div>
                  <Form form={form} onFinish={onFinish}>
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Item
                          name="first_name"
                          rules={[{ required: true }]}
                        >
                          <Input
                            prefix={<FaUserCircle />}
                            style={{ borderRadius: 0, height: 45 }}
                            placeholder="First Name"
                          />
                        </Form.Item>
                      </div>
                      <div className="col-md-6">
                        <Form.Item
                          name="last_name"
                          rules={[{ required: true }]}
                        >
                          <Input
                            prefix={<FaUserCircle />}
                            style={{ borderRadius: 0, height: 45 }}
                            placeholder="Last Name"
                          />
                        </Form.Item>
                      </div>
                      <Form.Item name="email" rules={[{ required: true }]}>
                        <Input
                          prefix={<MdEmail />}
                          style={{ borderRadius: 0, height: 45 }}
                          placeholder="Email"
                        />
                      </Form.Item>
                      <Form.Item name="message" rules={[{ required: true }]}>
                        <TextArea
                          style={{ borderRadius: 0 }}
                          rows={5}
                          showCount
                          placeholder="Message"
                        />
                      </Form.Item>
                      <Form.Item>
                        <Button className="submitForm" htmlType="submit">
                          SEND MESSAGE <IoMdSend />
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FooterCountry;
